import { usersFilterActions } from '../constants/filter';
import * as api from '../api/users';
import { asyncAction } from './common';

export const changeUsersEvent = (event) => ({
  type: 'CHANGE_USERS_EVENT',
  event,
});

export const setUsersEventColumnValue = (id, value) => ({
  type: 'SET_USERS_EVENT_COLUMNS_VALUE',
  id,
  value,
});

export const addUsersEventColumn = () => ({
  type: 'ADD_USERS_EVENT_COLUMN',
});

export const deleteUsersEventColumn = (id) => ({
  type: 'DELETE_USERS_EVENT_COLUMN',
  id,
});

export const aggregateUsers = (id) => ({
  type: 'AGGREGATE_USERS',
  id,
});

export const addFilterClause = () => ({
  type: usersFilterActions.ADD_FILTER_CLAUSE,
});

export const removeFilterClause = (clauseId) => ({
  type: usersFilterActions.REMOVE_FILTER_CLAUSE,
  id: clauseId,
});

export const setClausesConcatOperator = (value) => ({
  type: usersFilterActions.SET_CLAUSES_CONCAT_OPERATOR,
  value,
});

export const setFilterClauseField = (clauseId, field, fieldType) => ({
  type: usersFilterActions.SET_FILTER_CLAUSE_FIELD,
  id: clauseId,
  field,
  fieldType,
});

export const setFilterClauseValue = (clauseId, value) => ({
  type: usersFilterActions.SET_FILTER_CLAUSE_VALUE,
  id: clauseId,
  value,
});

export const setFilterVisibility = (value) => ({
  type: usersFilterActions.SET_FILTER_VISIBILITY,
  value,
});

export const removeFilter = () => ({
  type: usersFilterActions.REMOVE_FILTER,
});

export const copyFilter = (clauses) => ({
  type: usersFilterActions.COPY_FILTER,
  clauses,
});

export const setFilterClauseOperator = (clauseId, value, resetClauseValue) => ({
  type: usersFilterActions.SET_FILTER_CLAUSE_OPERATOR,
  id: clauseId,
  value,
  resetClauseValue,
});

export const setUsersExposureError = (error) => ({
  type: 'SET_USERS_EXPOSURE_ERROR',
  error,
});

export const setUsersExecuteId = (executeId) => ({
  type: 'SET_USERS_EXECUTE_ID',
  executeId,
});

export const executeUsers = (executeId) =>
  asyncAction('EXECUTE_USERS_EVENT_QUERY', api.executeUsersQuery(executeId));

const exposeEventErrorHandler = (dispatch, getState, errorText) =>
  dispatch(setUsersExposureError(errorText));

export const exposeUsersQuery = () =>
  asyncAction('EXPOSE_USERS_QUERY', api.exposeUsersQuery(), exposeEventErrorHandler);

export const executeUsersCsv = () =>
  asyncAction('EXECUTE_USERS_EVENT_QUERY_CSV', api.executeUsersCsvQuery());
